module.exports = __webpack_public_path__ + "static/media/ms.ec75da93.svg";